import "./scrollable.css";

import { Page, PageHeader } from "@nike/epic-react-ui";
import useSWR from "swr";
import GraphQLService from "../shared/GraphQLService";
import { Table } from "@nike/epic-react-ui";
import type { TableRef } from "@nike/epic-react-ui";
import React, { useRef } from "react";

import type { ColumnDef } from "@tanstack/react-table";
import type { Exception, EquipmentVehicle } from "../shared/Types";
import { Button, Text } from "@nike/eds";

const api = new GraphQLService();

const useEquipmentVehiclesApi = () => {
  const fetcher = async () => await api.getEquipmentVehicles();
  return useSWR({ type: "EquipmentVehicles" }, fetcher, {
    refreshInterval: 30000,
  });
};

export type TableColumn<T> = ColumnDef<T, any> & {
  header: string | React.ReactNode | (() => React.ReactNode);
  accessorKey: keyof T | string;
  filterType?: "select" | "text";
};

export const getTableColumns = (): TableColumn<EquipmentVehicle>[] => [
  {
    header: "ETA / Planned Discharge Date",
    accessorKey: "plannedDischargeDate",
    size: 100,
    cell: ({ row }) => {
      return new Date(row.original.plannedDischargeDate).toLocaleString(
        "en-US",
        {
          year: "numeric",
          month: "short",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        }
      );
    },
  },
  { header: "Mode of Transport", accessorKey: "modeOfTransport", size: 150 },
  { header: "Voyage Nbr", accessorKey: "voyageNumber", size: 100 },
  { header: "Carrier", accessorKey: "carrier", size: 100 },
  { header: "Consignments", accessorKey: "consignmentCount", size: 100 },
  { header: "Origin Country", accessorKey: "originCountry", size: 100 },
  { header: "Discharge Country", accessorKey: "dischargeCountry", size: 100 },
];

const EquipmentVehiclesTable = () => {
  const { data, isLoading, error } = useEquipmentVehiclesApi();
  console.log(
    "EquipmentVehiclesTable data",
    data?.data?.equipmentVehicle?.list?.items
  );



  const tableRef = useRef<TableRef>(null);

  if (isLoading) return <Text>Loading equipment vehicles...</Text>;
  if (error) return <div style={{ color: "red" }}>Error: {error.message}</div>;
  if (data?.data?.equipmentVehicle?.list?.items) {
    const rows = data.data.equipmentVehicle.list.items;

    console.log("EquipmentVehiclesTable rows", rows);
    return (
      <Table
        fullWidth
        ref={tableRef}
        columns={getTableColumns()}
        data={rows}
        enableSorting={true}
        enableGlobalFilter={false}
        disableStickyHeader={true}
        emptyState={{
          title: "No Voyages Found",
          description: "There are no voyages to display at this time.",
        }}
      />
    );
  }
  return <></>;
};
export function EquipmentVehicles({ history }) {
  return (
    <Page
      documentTitle="Equipment Vehicles - Customs Compliance Hub"
      width="full"
      className="scrollable"
    >
      <PageHeader
        title="Equipment Vehicles"
        summary="Track consignments associated with specific transport vehicles. Click any row to expand and view its associated consignments."
      />
      <EquipmentVehiclesTable />
    </Page>
  );
}
